document.addEventListener('DOMContentLoaded', async () => {
  const waBtn   = document.getElementById('waTriggerBtn');
  const waForm  = document.getElementById('waFlyoutForm');
  const waClose = document.getElementById('waCloseForm');
  const waLink  = document.getElementById('waSubmitLink');

  if (!waBtn || !waForm || !waClose || !waLink) {
    console.warn("[wa] кнопка или форма не найдены");
    return;
  }

  // --- Ожидаем появления CLabsgbVar.generalProps.uid
  async function waitForUserId(maxAttempts = 20, delay = 250) {
    return new Promise((resolve) => {
      let attempts = 0;
      const interval = setInterval(() => {
        try {
          if (window.CLabsgbVar && CLabsgbVar.generalProps && CLabsgbVar.generalProps.uid) {
            clearInterval(interval);
            resolve(CLabsgbVar.generalProps.uid);
          } else if (++attempts >= maxAttempts) {
            clearInterval(interval);
            console.warn("[WA] CLabsgbVar.uid не найден, продолжаем без него");
            resolve(null);
          }
        } catch (err) {
          clearInterval(interval);
          console.error("[WA] Ошибка при доступе к CLabsgbVar:", err);
          resolve(null);
        }
      }, delay);
    });
  }

  const userIdLab = await waitForUserId();
  console.log("User ID (Lab):", userIdLab);

  // --- Генерация локального ID
  function getUserId() {
    let uid = localStorage.getItem('wa_user_id');
    if (!uid) {
      uid = 'uid-' + Date.now().toString(36) + '-' + Math.random().toString(36).substr(2, 9);
      localStorage.setItem('wa_user_id', uid);
    }
    return uid;
  }
  const userId = getUserId();

  // --- Открытие / закрытие попапа
  function openForm() {
    console.log("[wa] открываем форму WhatsApp");
    waForm.classList.add("is-active");
    waBtn.classList.add("is-hidden");
  }

  function closeForm() {
    console.log("[wa] закрываем форму WhatsApp");
    waForm.classList.remove("is-active");
    waBtn.classList.remove("is-hidden");
  }

  ["click", "touchstart"].forEach(evt => {
    waBtn.addEventListener(evt, openForm, { passive: true });
    waClose.addEventListener(evt, closeForm, { passive: true });
  });

  // --- Валидация и вебхуки
  waLink.addEventListener('click', (e) => {
    const name  = document.getElementById('waName').value.trim();
    const phone = document.getElementById('waPhone').value.trim();

    if (!name || !phone) {
      e.preventDefault();
      alert('נא למלא שם וטלפון');
      return;
    }

    // WhatsApp-ссылка
    const waURL = `https://wa.me/972547425527?text=${encodeURIComponent(" היי שירי")}`;
    waLink.setAttribute('href', waURL);

    // Отправляем вебхуки (не блокируем переход)
    const payload = {
      userId,
      userIdLab,
      name,
      phone,
      page: window.location.href,
      timestamp: new Date().toISOString()
    };

    fetch("https://services.leadconnectorhq.com/hooks/0bU3FDKmuClgKlgHwuoI/webhook-trigger/c0d54fed-91a5-4e68-a906-e9110fc0a092", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    }).catch(err => console.error("Webhook #1 error:", err));

    fetch("https://hook.customerlabs.co/source/lead-4432/", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userId })
    }).catch(err => console.error("Webhook #2 error:", err));
  });
});